import { FC } from "react";
import { Link, WarningBanner } from "@postenbring/hedwig-react";
import { StatusPageInfo } from "@digipost/statusbanner/dist/src";
import { useTranslate } from "../infrastructure/translation/useTranslate";

const STATUS_PAGE_URL = "https://status.digipost.no";

export const StatusBanner: FC<{ statusPageInfo: StatusPageInfo[] }> = ({
  statusPageInfo,
}) => {
  const translate = useTranslate();

  if (statusPageInfo.length === 0) {
    return null;
  }

  const readMore = translate("status_banner.read_more");

  if (statusPageInfo.length > 1) {
    return (
      <WarningBanner
        title={
          <>
            {translate("status_banner.multiple")}{" "}
            <Link href={STATUS_PAGE_URL}>{readMore}</Link>
          </>
        }
      />
    );
  }

  const incident = statusPageInfo[0];
  const description =
    incident.type === "scheduled_maintenance"
      ? `${incident.maintenanceDate} - ${incident.maintenanceEndDate}: ${incident.name}`
      : incident.name;

  return (
    <WarningBanner
      title={
        <>
          {description} <Link href={incident.shortlink}>{readMore}</Link>
        </>
      }
    />
  );
};
